import * as _ from 'lodash-es';
import React from 'react';
import * as styles from './TemplatesSuggestions.module.scss';
import Button from '../components/Button';
import oneOnOneIcon from '../icons/non-prefilled/templates/1on1meetings.svg';
import agendasIcon from '../icons/non-prefilled/templates/agendas.svg';
import codeReviewIcon from '../icons/non-prefilled/templates/codeReview.svg';
import culturesAndValuesIcon from '../icons/non-prefilled/templates/culturesAndValues.svg';
import onboardingIcon from '../icons/non-prefilled/templates/onboarding.svg';
import postmortemsIcon from '../icons/non-prefilled/templates/postmortems.svg';
import recruitingIcon from '../icons/non-prefilled/templates/recruiting.svg';
import remoteWorkIcon from '../icons/non-prefilled/templates/remoteWork.svg';
import rfcsIcon from '../icons/non-prefilled/templates/rfcs.svg';
import styleGuidesIcon from '../icons/non-prefilled/templates/styleGuides.svg';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import { createPostPath } from '../utils/url/postPath';

const CATEGORIES = [
  {
    title: 'Culture and Values',
    link: 'culture-and-values',
    icon: culturesAndValuesIcon,
  },
  {
    title: 'One-on-One Meetings',
    link: 'one-on-one-meetings',
    icon: oneOnOneIcon,
  },
  {
    title: 'Writing Style Guides',
    link: 'writing-style-guides',
    icon: styleGuidesIcon,
  },
  {
    title: 'Code Review Guidelines',
    link: 'code-review-guidelines',
    icon: codeReviewIcon,
  },
  { title: 'Request for Comments (RFCs)', link: 'rfcs', icon: rfcsIcon },
  { title: 'Postmortems', link: 'postmortems', icon: postmortemsIcon },
  { title: 'Recruiting', link: 'recruiting', icon: recruitingIcon },
  {
    title: 'Employee Onboarding',
    link: 'employee-onboarding',
    icon: onboardingIcon,
  },
  { title: 'Remote Work', link: 'remote-work', icon: remoteWorkIcon },
  {
    title: 'Team Meeting Agendas',
    link: 'team-meeting-agendas',
    icon: agendasIcon,
  },
] as const;

const TemplatesSuggestions = () => {
  const isLarge = useIsSize(Sizes.LG);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        Use a curated template from Slab’s Library
      </h3>
      <div className={styles.description}>
        Get inspired by templates and examples from leaders in the industry
      </div>
      {(isLarge ? [3, 4, 3] : [10]).map((rowItems, index, arr) => {
        const start = _.sum(arr.slice(0, index));
        const end = start + rowItems;

        return (
          <div className={styles.templates} key={`${start}-${end}`}>
            {CATEGORIES.slice(start, end).map((category) => (
              <Button
                key={category.title}
                to={`https://go.slab.com/slab-library-${category.link}`}
                variant="secondary"
                icon={category.icon}
                target="_blank"
                rel="noopener noreferrer"
              >
                {category.title}
              </Button>
            ))}
          </div>
        );
      })}

      <div className={styles.separator}>
        <span className={styles.separatorText}>or</span>
      </div>
      <div className={styles.buttons}>
        <Button variant="primary" to={createPostPath({ type: 'template' })}>
          Create blank template
        </Button>
        <Button
          variant="secondary"
          to="https://go.slab.com/slab-library"
          target="_blank"
          rel="noopener noreferrer"
        >
          See all templates
        </Button>
      </div>
    </div>
  );
};

export default TemplatesSuggestions;
